import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class LoaderService {
  disable = false;

  // Number of HTTP requests currently in flight, maintained by LoaderInterceptor.
  // Manual hide() calls respect this so a single component cannot tear the spinner
  // down while other real requests are still loading.
  private pending = 0;

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading: Observable<boolean> = this.isLoadingSubject.asObservable();

  // Manual show — used by components for non-HTTP busy states.
  show() {
    this.isLoadingSubject.next(true);
  }

  // Manual hide — ignored while HTTP requests are still in flight so it cannot
  // hide the spinner before the data those requests carry has arrived.
  hide() {
    if (this.pending === 0) {
      this.isLoadingSubject.next(false);
    }
  }

  // Called by LoaderInterceptor when a counted request starts.
  requestStarted() {
    this.pending++;
    this.isLoadingSubject.next(true);
  }

  // Called by LoaderInterceptor when a counted request completes (or errors).
  requestEnded() {
    if (this.pending > 0) {
      this.pending--;
    }
    if (this.pending === 0) {
      this.isLoadingSubject.next(false);
    }
  }
}
